/* eslint-disable import/prefer-default-export */
const onBlur = (event) => {
  // console.log(`shift key: ${event.shiftKey}`);
  const element = event.target;
  const nextSelector = element.getAttribute('data-nextfocus');
  const nextElement = document.querySelector(nextSelector);
  if (!event.shiftKey && event.keyCode === 9 && nextElement !== null) {
    element.focus();
    setTimeout(() => {
      nextElement.focus();
    }, 0);
  }
  const prevSelector = event.target.getAttribute('data-prevfocus');
  const prevElement = document.querySelector(prevSelector);
  if (event.shiftKey && event.keyCode === 9 && prevElement !== null) {
    element.focus();
    setTimeout(() => {
      prevElement.focus();
    }, 0);
  }
};

const getSelectorString = element => (
  `.${element.classList.toString().replace(/\s/gi, '.')}`
);

const setTabFocus = (options) => {
  const {
    element,
    nextElement,
    prevElement,
  } = options;
  if (element === null) {
    return;
  }
  if (nextElement) {
    const nextSelector = getSelectorString(nextElement);
    element.setAttribute('data-nextfocus', nextSelector);
  }
  if (prevElement) {
    const prevSelector = getSelectorString(prevElement);
    element.setAttribute('data-prevfocus', prevSelector);
  }
  element.removeEventListener('keydown', onBlur);
  element.addEventListener('keydown', onBlur);
};

export {
  setTabFocus,
};
/* eslint-enable import/prefer-default-export */

